export const AUTH_HINT_COOKIE_NAME = "twt_auth_present";
export const AUTH_HINT_DOCUMENT_CLASS = "twt-auth-present";

// Runs from <head> before the public navigation paints. The shared marketing
// header renders both advisory destinations and CSS selects the right one, so
// SSR never has to guess a client-readable cookie and signed-in members do not
// watch “Get access” survive until hydration.
export const AUTH_HINT_PREPAINT_SCRIPT = `!function(){try{var e=document.cookie.split(";").some(function(e){return e.trim()==="${AUTH_HINT_COOKIE_NAME}=1"});document.documentElement.classList.toggle("${AUTH_HINT_DOCUMENT_CLASS}",e)}catch(e){}}();`;

export function hasAuthHintCookie(cookieHeader?: string): boolean {
  const cookies =
    cookieHeader ?? (typeof document === "undefined" ? "" : document.cookie);

  return cookies
    .split(";")
    .some((part) => part.trim() === `${AUTH_HINT_COOKIE_NAME}=1`);
}

export function syncAuthHintDocumentClass(hasAuthHint: boolean) {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle(
    AUTH_HINT_DOCUMENT_CLASS,
    hasAuthHint
  );
}
